import { useState } from "react";
import { Form } from "reactstrap";
import { APISD } from "../../../../../../../../config/apisd";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../../../../../../../../index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import ToastError from "../../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../../NotificationToast/ToastSuccess";

export default function ModalTipeLegerAdd(props) {
  const token = localStorage.getItem("token");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  const [form, setForm] = useState({ name_type: "" });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((previousForm) => ({
      ...previousForm,
      [name]: value,
    }));
  };

  const handleSubmit = useMutation(async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await APISD.post(
        "/api/type-leger/store",
        {
          name_type: form.name_type.trim(),
          user_id:
            localStorage.getItem("id_user") ||
            localStorage.getItem("user_id") ||
            "",
        },
        fetchParams
      );

      if (response?.status === 200) {
        ToastSuccess.fire({
          icon: "success",
          title: response.data.message,
        });
        props.GetResponseData();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal menyimpan data",
      });
    } finally {
      setIsSubmitting(false);
    }
  });

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-tambah-tipe-leger"
    >
      <div className="sims-modal-header">
        <div>
          <h5 id="modal-tambah-tipe-leger" className="sims-modal-title">
            Tambah Tipe Leger
          </h5>
        </div>

        <button
          type="button"
          className="sims-modal-close"
          onClick={props.onHide}
          aria-label="Tutup modal"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <Form onSubmit={(event) => handleSubmit.mutate(event)}>
        <div className="sims-modal-body">
          <div className="sims-form-group">
            <label className="sims-form-label" htmlFor="name_type_add">
              Nama Tipe Leger <span>*</span>
            </label>
            <input
              id="name_type_add"
              className="sims-form-input"
              autoFocus
              required
              autoComplete="off"
              type="text"
              name="name_type"
              onChange={handleChange}
              value={form.name_type}
              placeholder="Masukkan nama tipe leger"
              
            />
          </div>

        </div>

        <div className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                Menyimpan...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faFloppyDisk} />
                Tambahkan
              </>
            )}
          </button>
        </div>
      </Form>
    </Modal>
  );
}
